<template>
  <div id="page_auth" class="page_auth">
    <header class="auth_header">
      <div class="price_container">
        <!-- <a href="/">
          <img src="../../assets/images/blue_icon_main.png" />
        </a> -->
        <!-- <blu-prices-header></blu-prices-header> -->
      </div>
      <base-language-bar></base-language-bar>
    </header>

    <div class="auth_body">
      <router-view></router-view>
    </div>

    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseLanguageBar from "../../components/public/BaseLanguageBar";
import BaseFooter from "../../components/public/BaseFooter";
import BluPricesHeader from "../../components/public/BluPricesHeader";
import { mapGetters } from "vuex";

export default {
  created() {
    this.$store.dispatch("getCurrencies");
    this.$store.dispatch("getFundTailsBtc");
  },
  components: {
    BaseLanguageBar,
    BaseFooter,
    BluPricesHeader,
  },
  computed: {
    ...mapGetters(["currencies"]),
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/public/Welcome.vue